// grid — wireframe skin module
// NO external imports — plain JavaScript only

export const styles = `
  :host {
    display: block;
    box-sizing: border-box;
  }

  [part="base"] {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }
`;

export function render(host) {
  const style = _buildStyle(host);
  const existing = host.shadowRoot.querySelector('[part="base"]');
  if (existing) {
    existing.setAttribute('style', style);
  } else {
    host.shadowRoot.innerHTML = `<div part="base" style="${style}"><slot></slot></div>`;
  }
}

function _buildStyle(host) {
  const p = [];

  p.push(`display:${host.inline ? 'inline-grid' : 'grid'}`);

  if (host._resolvedColumns) p.push(`grid-template-columns:${host._resolvedColumns}`);
  if (host.rows)             p.push(`grid-template-rows:${host.rows}`);
  if (host.areas)            p.push(`grid-template-areas:${host.areas}`);

  const hasGapX = Boolean(host.gapX);
  const hasGapY = Boolean(host.gapY);
  if (!hasGapX && !hasGapY) {
    if (host._resolvedGap) p.push(`gap:${host._resolvedGap}`);
  } else {
    if (host._resolvedGapX) p.push(`column-gap:${host._resolvedGapX}`);
    if (host._resolvedGapY) p.push(`row-gap:${host._resolvedGapY}`);
  }

  if (host.align)          p.push(`align-items:${host.align}`);
  if (host.justify)        p.push(`justify-items:${host.justify}`);
  if (host.placeItems)     p.push(`place-items:${host.placeItems}`);
  if (host.alignContent)   p.push(`align-content:${host.alignContent}`);
  if (host.justifyContent) p.push(`justify-content:${host.justifyContent}`);

  if (host.autoRows)    p.push(`grid-auto-rows:${host.autoRows}`);
  if (host.autoColumns) p.push(`grid-auto-columns:${host.autoColumns}`);

  const cssFlow = _flowToCss(host.flow);
  if (cssFlow) p.push(`grid-auto-flow:${cssFlow}`);

  // Wireframe additions
  p.push('border:1px dashed');
  p.push('border-radius:var(--run-wf-radius)');

  return p.join(';');
}

function _flowToCss(flow) {
  if (!flow || flow === 'row') return '';
  return flow.replace('-dense', ' dense');
}
